import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { SizesKeysType } from "@/types/sizes.type";
import { SizesKeys } from "@/types/sizes.type";

//Component types & definitions
import {
  VariantKeys,
  VariantsType,
  variants, 
  fontSizes,
} from "./Title";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseTitle',
  props: {
    variant: { default: VariantKeys.primary },
    size: { default: SizesKeys.default }
  },
  setup(__props: any) {

// Types



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", {
    class: _normalizeClass([
      _unref(variants)[_ctx.variant].classes,
      _unref(variants)[_ctx.variant].default,
      _unref(fontSizes)[_ctx.size],
    ])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})